module.exports = __webpack_public_path__ + "static/img/c3.ed52dc27.png";